<p-toast position="top-center"></p-toast>
<app-preloader *ngIf="load"></app-preloader>
<router-outlet></router-outlet>

